import React, { useContext } from 'react';
import { View, GestureResponderEvent, StyleSheet } from 'react-native';
import { GradientButton, Text, ThemeContext, TranslationsContext } from '..';

const getStyles = ({ colors, font, spacing }: Theme) =>
  StyleSheet.create({
    button: {
      paddingTop: spacing.unit * 3,
    },
    container: {
      backgroundColor: colors.background,

      justifyContent: 'center',
      padding: spacing.unit * 6,
    },
    text: {
      alignItems: 'center',
      color: colors.primary.normal,
      fontSize: font.size.xLarge,
      fontWeight: font.weight.normal,
      padding: spacing.unit / 2,
    },
  });

export interface ErrorMessageRetryBackdropProps {
  errorMessage?: string;
  onRetry?: (event: GestureResponderEvent) => void;
}

export const ErrorMessageRetryBackdrop = ({ errorMessage, onRetry }: ErrorMessageRetryBackdropProps) => {
  const translations = useContext(TranslationsContext);
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  return (
    <View style={styles.container}>
      {errorMessage ? (
        <Text style={styles.text}>{errorMessage}</Text>
      ) : (
        <View>
          <Text style={styles.text}>{translations.errors.modal.title}</Text>
          <Text style={styles.text}>{translations.errors.modal.message}</Text>
        </View>
      )}
      {onRetry ? (
        <GradientButton
          text={translations.components.error_message_retry_backdrop.retry}
          style={styles.button}
          onPress={onRetry}
        />
      ) : null}
    </View>
  );
};
